/**
 * WebSocket utility functions for connecting to the backend
 * Automatically detects development vs production environment
 */

/**
 * Get the appropriate WebSocket URL based on the environment
 * @returns {string} WebSocket URL
 */
export const getWebSocketUrl = () => {
  // Development: React dev server runs on port 3000, backend on 3001
  // Production: Apache serves the app (port 80/443), proxies WebSocket to /ws
  const isDevelopment = window.location.port === '3000';
  
  if (isDevelopment) {
    // Development mode: direct connection to backend on port 3001
    const wsPort = process.env.REACT_APP_WS_PORT || '3001';
    const wsUrl = `ws://${window.location.hostname}:${wsPort}`;
    console.log('🔌 Connecting to WebSocket (development):', wsUrl);
    return wsUrl;
  } else {
    // Production mode: use Apache proxy with /ws path
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const wsUrl = `${protocol}//${window.location.host}/ws`;
    console.log('🔌 Connecting to WebSocket (production):', wsUrl);
    return wsUrl;
  }
};

/**
 * Check if running in development mode
 * @returns {boolean}
 */
export const isDevelopmentMode = () => {
  return window.location.port === '3000';
};
